// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.min-height-vh-triggered {
  min-height: 800px;
  max-height: calc(100vh - 110px);
  height: calc(100vh - 110px);
}

.table_list {
  transition: 0.3s;
}

.registered_slider {
  letter-spacing: 0.2px;
  margin-bottom: 1rem;
  font-weight: 500;
}

.table-container {
  display: flex;
  flex-grow: 1;
}

.table {
  margin-bottom: 0;
}

.table th {
  padding: 0.5rem;
  font-weight: 600;
  font-size: 0.9rem;
}

.table td {
  vertical-align: middle;
  padding: 0.5rem;
}

.table td mat-checkbox label {
  margin: 0 !important;
}

tr.mat-row {
  cursor: pointer;
}

tr.mat-row.highlighted {
  background-color: rgba(159, 170, 229, 0.5);
  margin: 0 -15px;
  border-radius: 3px;
}

.status-info-container {
  text-shadow: 2px 2px 5px #b5b5b5;
}

.delete-btn-color {
  color: #A72925;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/user-pending-list/user-pending-list.component.scss"],"names":[],"mappings":"AAAA;EAEI,iBAAA;EAEA,+BAAA;EACA,2BAAA;AADJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,qBAAA;EACA,mBAAA;EACA,gBAAA;AAFJ;;AAKA;EACI,aAAA;EACA,YAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAUA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAPJ;;AAUA;EACI,sBAAA;EACA,eAAA;AAPJ;;AAUA;EACI,oBAAA;AAPJ;;AAUA;EAEI,eAAA;AARJ;;AAWA;EACI,0CAAA;EACA,eAAA;EACA,kBAAA;AARJ;;AAWA;EAEI,gCAAA;AATJ;;AAcA;EACI,cAAA;AAXJ","sourcesContent":[".min-height-vh-triggered {\r\n    // height: calc(100vh - 110px - 0.25rem);\r\n    min-height: 800px;\r\n    // max-height: calc(100vh - 110px - 0.25rem);\r\n    max-height: calc(100vh - 110px);\r\n    height: calc(100vh - 110px);\r\n\r\n}\r\n\r\n.table_list {\r\n    transition: 0.3s;\r\n}\r\n\r\n.registered_slider {\r\n    letter-spacing: .2px;\r\n    margin-bottom: 1rem;\r\n    font-weight: 500;\r\n}\r\n\r\n.table-container {\r\n    display: flex;\r\n    flex-grow: 1;\r\n}\r\n\r\n.table {\r\n    margin-bottom: 0;\r\n    // font-family:inherit;\r\n}\r\n\r\n//   .mat-cell {\r\n//     // font-size: 12px;\r\n//   }\r\n\r\n.table th {\r\n    padding: .5rem;\r\n    font-weight: 600;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.table td {\r\n    vertical-align: middle;\r\n    padding: .5rem\r\n}\r\n\r\n.table td mat-checkbox label {\r\n    margin: 0 !important\r\n}\r\n\r\ntr.mat-row {\r\n    // height: 47px;\r\n    cursor: pointer;\r\n}\r\n\r\ntr.mat-row.highlighted {\r\n    background-color: rgba(159, 170, 229, 0.5);\r\n    margin: 0 -15px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.status-info-container {\r\n\r\n    text-shadow: 2px 2px 5px #b5b5b5;\r\n}\r\n\r\n\r\n\r\n.delete-btn-color {\r\n    color: #A72925;\r\n    // background-color: #A72925;\r\n\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
